<script setup lang="ts">

import type NewsItem from "@/types/NewsItem.ts";
import ModalTrigger from "@/components/Interface/Modal/ModalTrigger.vue";
import { usePlayerRelationStore } from '@/stores/playerRelations.ts'
import NewsItemBaseStructure from '@/components/Sections/News/Types/Base/NewsItemBaseStructure.vue'
import NewsItemBase from '@/components/Sections/News/Types/Base/NewsItemBase.vue'

const playerRelationStore = usePlayerRelationStore();

const props = defineProps<{
  newsItem: NewsItem,
  toast: boolean
}>();

</script>

<template>
  <NewsItemBase
    :toast="toast"
    :toast-image="props.newsItem.contentData.profileImage"
    :toast-text="props.newsItem.contentData.nickname + ' wants peace.'"
  >
    <ModalTrigger type="requestAudience" :data="{'relation': playerRelationStore.findRelationByPlayerId( props.newsItem.contentData.playerId)}" >
      <NewsItemBaseStructure
        :newsItem="props.newsItem"
        :item-image="props.newsItem.contentData.profileImage"
        :header="props.newsItem.contentData.nickname + ' wants peace.'"
      >
        {{ props.newsItem.contentData.nickname }} wants peace.
      </NewsItemBaseStructure>
    </ModalTrigger>
  </NewsItemBase>
</template>

<style scoped lang="scss">

</style>